import routes from '@/config/routes';
import { v3Get, v3Post } from '@/api/axios.instance.V3';
import type { ApiResponse } from '../types';

import { IInterviewQuestionPayload, IInterviewQuestionSavePayload } from '@/store/admin/types/types';

const getAllInterviewQuestionsList = (gigId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.interviewQuestions.allClientInterviewQuestionsList}${gigId}`);
const getQuestionCategoriesList = (): ApiResponse => v3Get(`${routes.backendUrl.interviewQuestions.categoriesList}`);
const getInterviewQuestionsList = (gigId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.interviewQuestions.interviewQuestionList}/${gigId}`);
const arrangeQuestionOrder = (payload: IInterviewQuestionPayload): ApiResponse =>
  v3Post(routes.backendUrl.interviewQuestions.arrangeQuestionOrder, payload);
const saveInterviewQuestion = (payload: IInterviewQuestionSavePayload): ApiResponse =>
  v3Post(routes.backendUrl.interviewQuestions.saveInterviewQuestion, payload);

export const interviewQuestionApi = {
  getAllInterviewQuestionsList,
  getQuestionCategoriesList,
  getInterviewQuestionsList,
  arrangeQuestionOrder,
  saveInterviewQuestion,
};
